export default __webpack_public_path__ + "static/media/airplay.a6d63477.svg";